<truelearn-web-dialog>
    <ng-template #headerTemplate>
        <h1>Change Institution</h1>
        <button type="button" class="btn btn-link align-self-end" (click)="onClose()">
            <i class="fal fa-times fa-lg text-grey-600"><span class="visually-hidden-focusable">Close</span></i>
        </button>
    </ng-template>
    <ng-template #bodyTemplate>
        <div class="form-group mb-4">
            <label class="form-label" for="institutionSelect"> Institution </label>
            <select id="institutionSelect" class="form-select" [(ngModel)]="selectedId">
                @for (institution of data.institutions; track institution.id) {
                    <option [value]="institution.id">{{ institution.text }}</option>
                }
            </select>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <button
            type="button"
            class="btn btn-primary me-2"
            (click)="onSave()"
            [disabled]="!selectedId || selectedId === data.selectedId"
        >
            Select
        </button>
        <button type="button" class="btn btn-outline-primary" (click)="onClose()"> Cancel </button>
    </ng-template>
</truelearn-web-dialog>
